import { get } from '../index';

export const getVersions = () => {
  return get(`/data/versions`, true);
};
